<template>
  <div v-bind:class="{backgroundVideo: true, transparent}">
    <video ref="backgroundVideo" autoplay muted loop>
      <source v-for="source in sources" :src="source.src" :type="source.type">
    </video>
    <slot></slot>
  </div>
</template>

<script>

  export default {
    name: 'BackgroundVideo',
    props: ['sources', 'speed'],
    data() {
      return {
        video: false,
        transparent: true,
      }
    },
    methods: {
      onCanPlayThrough() {
        this.transparent = false;
        this.$emit('canPlayThrough');
      }
    },

    mounted() {
      this.video = this.$refs.backgroundVideo;
      console.log(this.video, this.video.playbackRate, this.video.canplaythrough)
      if (this.speed) {
        this.video.playbackRate = this.speed;
      }

      if (this.video.readystatechange >= 4) this.onCanPlayThrough();
      this.video.oncanplaythrough = this.onCanPlayThrough;
    }
  }
</script>

<style lang="scss">
.backgroundVideo {
  height: 100vh;
  overflow: hidden;
  position: relative;

video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  object-fit: cover;
  filter: blur(20px);
  transform: scale(1.2);



  &.transparent {
    opacity: 0;
  }
}
}


</style>
